import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { FiltersService } from 'src/app/services/filters.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-filter-save',
    templateUrl: './filter-save.component.html',
    styleUrls: ['./filter-save.component.scss'],
    standalone: false
})
export class FilterSaveComponent implements OnInit {
  onEdit: boolean = false;
  filtersForm = new FormGroup({
    id: new FormControl(),
    label: new FormControl([], [Validators.required]),
    default: new FormControl(false)
  });
  filters: any;

  constructor(
    private dialogRef: MatDialogRef<FilterSaveComponent>,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private filtersService: FiltersService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data.action === 'edit') {
      this.onEdit = true;
      this.filtersForm.patchValue({
        id: data.selected.id,
        label: data.selected.label,
        default: data.selected.default
      });
    }
    this.filters = data.filters;
  }

  ngOnInit(): void { }

  save() {
    this.filtersService.addPredefinedSearch(this.filtersForm.value, this.filters).subscribe(resp => {
      this.dialogRef.close({ action: this.data.action, successMsg: 'filters.dialog.form.add_success', data: resp.predefinedSearch });
    }, err => {
      this.toastr.error(err);
    });
  }

  update() {
    this.filtersService.updatePredefinedSearch(this.filtersForm.value, this.filters).subscribe(resp => {
      this.dialogRef.close({ action: this.data.action, successMsg: 'filters.dialog.form.edit_success', data: resp.predefinedSearch });
    }, err => {
      this.toastr.error(err);
    });
  }

  delete() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: this.translateService.instant('filters.dialog.delete.title'),
        body: this.translateService.instant('filters.dialog.delete.body')
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.filtersService.deletePredefinedSearch(this.data.selected.id).subscribe(resp => {
          this.dialogRef.close({ action: 'delete', successMsg: 'filters.dialog.delete.success', data: this.data.selected.id });
        }, err => {
          this.toastr.error(err);
          this.dialogRef.close(false);
          throw Error(err);
        });
      }
    });
  }

}
